import { tableSlotKey } from './tableReservationEligibility';

export type TableSlotStatus =
  | 'available'
  | 'held'
  | 'sold'
  | 'blocked'
  | 'expired'
  | 'expiring';

export function normalizeTableSlotStatus(s: string | undefined): TableSlotStatus {
  const v = (s || 'available').toLowerCase();
  if (
    v === 'available' ||
    v === 'held' ||
    v === 'sold' ||
    v === 'blocked' ||
    v === 'expired' ||
    v === 'expiring'
  ) {
    return v;
  }
  return 'available';
}

/** Match meeteor-web `statusForTableSlot` / `table_availability` keys. */
export function statusForTableSlot(
  tableId: string,
  slot: { day: string; start_time: string; end_time: string } | null | undefined,
  availability: Record<string, string> | undefined,
): TableSlotStatus {
  if (!availability || typeof availability !== 'object') return 'available';
  if (!slot) {
    const st = availability[tableId];
    return normalizeTableSlotStatus(typeof st === 'string' ? st : undefined);
  }
  const key = tableSlotKey(tableId, slot);
  const direct = availability[key];
  if (typeof direct === 'string') return normalizeTableSlotStatus(direct);
  return 'available';
}

export function tableSelectionKey(
  tableId: string,
  timeSlot: { day: string; start_time: string; end_time: string } | undefined,
): string {
  return timeSlot
    ? tableSlotKey(tableId, timeSlot)
    : tableId;
}

export function formatTime12h(hhmm: string): string {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
  if (!m) return hhmm;
  let h = parseInt(m[1], 10);
  const min = m[2];
  const ap = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${min} ${ap}`;
}

/** meeteor-web `slotLabel` */
export function slotLabel(slot: {
  day?: string;
  start_time?: string;
  end_time?: string;
}): string {
  const d = slot.day ? String(slot.day).slice(0, 3).toUpperCase() : '';
  const a = slot.start_time ? formatTime12h(slot.start_time) : '';
  const b = slot.end_time ? formatTime12h(slot.end_time) : '';
  if (d && a && b) return `${d} ${a} – ${b}`;
  if (a && b) return `${a} – ${b}`;
  return d || 'Slot';
}

export function tableStatusPillText(status: TableSlotStatus): string {
  if (status === 'sold') return 'Sold';
  if (status === 'held') return 'Held';
  if (status === 'blocked') return 'Blocked';
  if (status === 'expired' || status === 'expiring') return 'Unavailable';
  return 'Available';
}
